const allAccountsLabel = 'Tous les comptes'
const orphansLabel = 'Sans parent'

export { allAccountsLabel, orphansLabel }
